import { render } from "./PublicView.vue?vue&type=template&id=a5af98c2&scoped=true"
import script from "./PublicView.vue?vue&type=script&lang=js"
export * from "./PublicView.vue?vue&type=script&lang=js"

import "./PublicView.vue?vue&type=style&index=0&id=a5af98c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5af98c2"]])

export default __exports__